import type { CartItem } from "../store/useStore";
import { useStore } from "../store/useStore";
import { t } from "../lib/i18n";
import { BRAND_TAG } from "../lib/brand";

type Props = {
  items: CartItem[];
  total: number;
  expanded?: boolean;
  onClick?: () => void;
  className?: string;
};

export function ReceiptRoll({ items, total, expanded = false, onClick, className = "" }: Props) {
  const lang = useStore((s) => s.language);
  const lineCount = items.reduce((s, c) => s + c.qty, 0);
  const itemsLabel = lineCount === 1 ? t(lang, "receipt_items_one") : t(lang, "receipt_items_many");

  return (
    <div
      onClick={onClick}
      className={`bg-paper text-ink shadow-[0_-8px_24px_-8px_rgba(26,22,18,0.4)] cursor-pointer ${className}`}
      style={{
        clipPath:
          "polygon(0 0, 100% 0, 100% calc(100% - 8px), 95% 100%, 90% calc(100% - 8px), 85% 100%, 80% calc(100% - 8px), 75% 100%, 70% calc(100% - 8px), 65% 100%, 60% calc(100% - 8px), 55% 100%, 50% calc(100% - 8px), 45% 100%, 40% calc(100% - 8px), 35% 100%, 30% calc(100% - 8px), 25% 100%, 20% calc(100% - 8px), 15% 100%, 10% calc(100% - 8px), 5% 100%, 0 calc(100% - 8px))",
      }}
    >
      <div className="px-5 pt-3 pb-5">
        <div className="text-center font-display font-bold tracking-widest text-xs uppercase opacity-70">
          {t(lang, "receipt_your_account")}
        </div>
        <div className="text-center font-mono text-[10px] tracking-widest opacity-50 mt-0.5">{BRAND_TAG}</div>

        {!expanded && (
          <div className="flex items-baseline justify-between mt-3">
            <span className="font-mono text-xs uppercase tracking-widest">{lineCount} {itemsLabel}</span>
            <span className="font-display text-3xl font-bold tabular-nums">${total}</span>
          </div>
        )}

        {expanded && (
          <div className="mt-3 font-mono text-sm">
            <div className="border-t border-dashed border-ink/40 pt-2" />
            {items.map((it) => (
              <div key={it.sku} className="flex justify-between leading-relaxed">
                <span className="truncate pr-2">{it.qty}× {it.product.name}</span>
                <span className="tabular-nums">${it.qty * it.product.price}</span>
              </div>
            ))}
            <div className="border-t border-dashed border-ink/40 mt-2 pt-2 flex justify-between font-bold text-lg">
              <span>{t(lang, "receipt_total")}</span>
              <span className="tabular-nums">${total}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
